// extracted by mini-css-extract-plugin
module.exports = {"container":"ChartLockedSpacer_container__m7vbG","content":"ChartLockedSpacer_content__2aNwV","message":"ChartLockedSpacer_message__1KtSr"};